import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { AuthMode } from "@/features/auth/hooks/auth/useLoginAuth";

interface LoginModeSwitcherProps {
  mode: AuthMode;
  resetSent: boolean;
  onSwitchMode: (mode: AuthMode) => void;
}

const actionClassName =
  "h-auto p-0 align-baseline font-semibold text-primary hover:text-foreground";

export default function LoginModeSwitcher({
  mode,
  resetSent,
  onSwitchMode,
}: LoginModeSwitcherProps) {
  const { t } = useTranslation(["auth"]);
  return (
    <div className="mt-6 border-t border-[var(--border)] pt-5 text-center text-sm text-[var(--muted-foreground)]">
      {mode === "login" && (
        <>
          <Button
            variant="link"
            onClick={() => onSwitchMode("reset")}
            className={actionClassName}
            data-test="login-forgot-password"
          >
            {t("auth:login.forgotPassword")}
          </Button>
          <span className="mx-2 text-[var(--border)]">|</span>
          <span>
            {t("auth:login.noAccount")} {" "}
            <Button
              variant="link"
              onClick={() => onSwitchMode("register")}
              className={actionClassName}
              data-test="login-switch-register"
            >
              {t("auth:login.signUp")}
            </Button>
          </span>
        </>
      )}

      {mode === "register" && (
        <span>
          {t("auth:register.haveAccount")} {" "}
          <Button
            variant="link"
            onClick={() => onSwitchMode("login")}
            className={actionClassName}
            data-test="login-switch-login"
          >
            {t("auth:register.signIn")}
          </Button>
        </span>
      )}

      {mode === "reset" && !resetSent && (
        <Button
          variant="link"
          onClick={() => onSwitchMode("login")}
          className={actionClassName}
          data-test="login-back-to-signin"
        >
          {t("auth:reset.backToSignIn")}
        </Button>
      )}
    </div>
  );
}
